var _mask, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_3043_52388",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 12C22.5 17.5228 18.0228 22 12.5 22C6.97715 22 2.5 17.5228 2.5 12C2.5 6.47715 6.97715 2 12.5 2C18.0228 2 22.5 6.47715 22.5 12Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.03216 11.4924C8.74029 11.1985 8.26542 11.1968 7.97151 11.4887C7.6776 11.7806 7.67596 12.2554 7.96784 12.5493L9.03216 11.4924ZM11.4293 14.9705L10.8971 15.499L10.8971 15.499L11.4293 14.9705ZM18.0322 9.52849C18.324 9.23458 18.3224 8.75971 18.0285 8.46784C17.7346 8.17596 17.2597 8.1776 16.9678 8.47151L18.0322 9.52849ZM11.5707 14.9705L12.1029 15.499L12.1029 15.499L11.5707 14.9705ZM7.96784 12.5493L10.8971 15.499L11.9615 14.442L9.03216 11.4924L7.96784 12.5493ZM16.9678 8.47151L11.0385 14.442L12.1029 15.499L18.0322 9.52849L16.9678 8.47151ZM10.8971 15.499C11.2295 15.8337 11.7705 15.8337 12.1029 15.499L11.0385 14.442C11.2928 14.186 11.7072 14.186 11.9615 14.442L10.8971 15.499ZM21 12C21 16.6944 17.1944 20.5 12.5 20.5V23.5C18.8513 23.5 24 18.3513 24 12H21ZM12.5 20.5C7.80558 20.5 4 16.6944 4 12H1C1 18.3513 6.14873 23.5 12.5 23.5V20.5ZM4 12C4 7.30558 7.80558 3.5 12.5 3.5V0.5C6.14873 0.5 1 5.64873 1 12H4ZM12.5 3.5C17.1944 3.5 21 7.30558 21 12H24C24 5.64873 18.8513 0.5 12.5 0.5V3.5Z",
    fill: "currentColor",
    mask: "url(#path-1-inside-1_3043_52388)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck2);
export default __webpack_public_path__ + "static/media/check_2.25b8ebb98a40afaf7ac9cabb3b74b8fa.svg";
export { ForwardRef as ReactComponent };